<script setup lang="ts">
import FolderAvatar from './FolderAvatar.vue'
import { storeToRefs } from 'pinia'
import { useLibraryStore } from './library.store'
import { useContributorVisibility } from './composables/useContributorVisibility'
import { computed } from 'vue'

interface Props {
    contentId: string,
}
const props = withDefaults(defineProps<Props>(), {
    contentId: ''
})

const libraryStore = useLibraryStore()
const { currentFolder, doesUserOwnCurrentFolder } = storeToRefs(libraryStore)
const { contributorInfo, contributorIsVisible } = useContributorVisibility(props.contentId)

const showNewContentBadge = computed(() => {
  if (!props.contentId || !currentFolder.value?.uuid || !doesUserOwnCurrentFolder.value) {
    return false
  }
  return libraryStore.isContentNew(props.contentId, currentFolder.value.uuid)
})
</script>

<template>
    <div
     v-if="contributorIsVisible"
     class="text-blue-500 text-center text-[12px] font-normal leading-[18px] inline-flex items-center">
        <span class="mr-2">Contributed by</span>
        <FolderAvatar :userId="contributorInfo.contributor" :folder="currentFolder" avatarSize="sm"/>
        <span v-if="showNewContentBadge" class="bg-blue-600 text-white text-sm font-medium px-2 py-0.5 rounded-[1.5rem] uppercase">NEW</span>
    </div>
</template>
